define(['common/parameterApplications'], function(parameterApplications) {
    var fieldName = 'contentType';

    return {
        setField: function(fields) {
            var copiedFields = Object.assign({}, fields);
            copiedFields[fieldName] = {
                application: parameterApplications.PATH
            };
            return copiedFields;
        },

        setValue: function(requestOptions) {
            requestOptions[fieldName] = 'json';
            return requestOptions;
        }
    };
});



// WEBPACK FOOTER //
// ./rest/request/contentTypeConfigurer.js